import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import AnimatedSection from '@/components/ui/AnimatedSection';

export default function AboutPreview() {
    return (
        <section className="py-24 bg-white overflow-hidden">
            <div className="container mx-auto px-6">
                <div className="flex flex-col lg:flex-row items-center gap-16">

                    {/* Image Grid */}
                    <div className="w-full lg:w-1/2 relative">
                        <AnimatedSection className="grid grid-cols-2 gap-4">
                            <div className="space-y-4 translate-y-8">
                                <img
                                    src="/images/about-conference.png"
                                    alt="Conférence"
                                    className="rounded-2xl shadow-lg w-full h-64 object-cover"
                                />
                                <img
                                    src="/images/about-city.jpg"
                                    alt="Ville de Gand"
                                    className="rounded-2xl shadow-lg w-full h-auto object-contain bg-gray-100"
                                />
                            </div>
                            <div className="space-y-4">
                                <img
                                    src="/images/about-music.png"
                                    alt="Musique à l'UTA"
                                    className="rounded-2xl shadow-lg w-full h-48 object-cover"
                                />
                                <img
                                    src="/images/about-group.jpg"
                                    alt="Groupe UTA devant la cathédrale"
                                    className="rounded-2xl shadow-lg w-full h-64 object-cover"
                                />
                            </div>
                        </AnimatedSection>

                        {/* Decorative blob */}
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-primary-100/50 rounded-full blur-3xl -z-10"></div>
                    </div>

                    {/* Content */}
                    <div className="w-full lg:w-1/2">
                        <AnimatedSection delay={0.2}>
                            <div className="inline-block px-3 py-1 bg-accent-100 text-accent-800 rounded-full text-sm font-bold mb-4">
                                À Propos
                            </div>
                            <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary-900 mb-6">
                                Cultiver l'esprit, <br />
                                <span className="text-primary-500">tisser des liens.</span>
                            </h2>
                            <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                                L'Université de Tous Âges Nord-Luxembourg (Barvaux-sur-Ourthe) est un lieu de rencontre et d'échange, ouvert à tous, sans condition d'âge ni de diplôme.
                            </p>
                            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                                Notre mission est de promouvoir la culture, la formation continue et le lien social à travers un programme varié de conférences, d'excursions et de moments conviviaux.
                            </p>

                            <Link
                                to="/a-propos"
                                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-900 text-white rounded-lg font-medium hover:bg-primary-800 transition-colors shadow-lg hover:shadow-xl hover:-translate-y-1 transform duration-200"
                            >
                                En savoir plus sur l'ASBL
                                <ArrowRight size={20} />
                            </Link>
                        </AnimatedSection>
                    </div>

                </div>
            </div>
        </section>
    );
}
